export const ArrowLeftIcon = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="5"
    height="10"
    viewBox="0 0 5 10"
    fill="none"
  >
    <path
      d="M4.21915 9.66709C4.11939 9.66719 4.02089 9.6449 3.93089 9.60186C3.84089 9.55882 3.7617 9.49614 3.69915 9.41843L0.480485 5.41843C0.383802 5.29839 0.331696 5.14857 0.333033 4.99445C0.33437 4.84033 0.389067 4.69143 0.487818 4.57309L3.82115 0.573092C3.87641 0.503456 3.94503 0.445572 4.02298 0.402848C4.10094 0.360123 4.18665 0.333421 4.27507 0.324311C4.3635 0.315201 4.45286 0.323868 4.53788 0.349801C4.62291 0.375735 4.70189 0.418411 4.77018 0.47532C4.83848 0.532229 4.89469 0.602221 4.93554 0.681178C4.97638 0.760135 5.00102 0.846463 5.008 0.935082C5.01499 1.0237 5.00418 1.11282 4.97621 1.1972C4.94824 1.28159 4.90368 1.35952 4.84515 1.42643L1.86182 5.00709L4.73849 8.58176C4.81753 8.67971 4.86723 8.79803 4.88184 8.92304C4.89645 9.04805 4.87537 9.17465 4.82104 9.28818C4.76672 9.40171 4.68136 9.49755 4.57485 9.5646C4.46833 9.63166 4.34501 9.66719 4.21915 9.66709Z"
      fill="currentColor"
    />
  </svg>
)
